import ReleaseNotesView from "@/views/ReleaseNote/ReleaseNotesView.vue";
import { i18n } from "@/i18n";
export default {
  path: "/release-note",
  name: "ReleaseNotes",
  component: ReleaseNotesView,
  meta: {
    authRequired: true,
    title: i18n.global.t("Notes de versions"),
    breadcrumb: true,
  },
};
